<!--
  ~ Copyright (c) Worldline 2023.
  -->

<main role="main">
    <h2>
        {{ 'session.wait' | translate }}
    </h2>
    <section class="infoBox" *ngIf="this.errorMsg">
        <p>{{ this.errorMsg | translate }}</p>
    </section>
</main>
